// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var NavController = function ($scope, $routeParams, $rootScope, $location) {
    $scope.logoff = function () {
        $rootScope.username = null;
        $rootScope.password = null;
        $rootScope.accessToken = null;
        $rootScope.refreshToken = null;
        localStorage.removeItem('username');
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
    };
};
NavController.$inject = ['$scope', '$routeParams', '$rootScope', '$location'];
